import ResetPasswordForm from "../../components/auth/forms/ResetPasswordForm";

const ResetPasswordPage = () => {

  return (
    <ResetPasswordForm />
  );
};

export default ResetPasswordPage;
